import { render } from "./UserRewardKingdomLeaderboards.vue?vue&type=template&id=c11545a6"
import script from "./UserRewardKingdomLeaderboards.vue?vue&type=script&lang=js"
export * from "./UserRewardKingdomLeaderboards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__